import { useEffect } from 'react';

export const useVideoLoadingEvents = ({ playerRef, setIsLoading }) => {
  useEffect(() => {
    if (!playerRef?.current) return;
    const videoElement = playerRef.current;

    const endLoading = () => {
      setIsLoading(false);
    };

    videoElement.addEventListener('canplay', endLoading);
    videoElement.addEventListener('timeupdate', endLoading);

    // cleanup
    return () => {
      videoElement.removeEventListener('canplay', endLoading);
      videoElement.removeEventListener('timeupdate', endLoading);
    };
  }, [setIsLoading, playerRef]);
};
